import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

// Custom rounded button for consistent app-wide use
const StyledButton = styled(Button)(({ theme, varianttype }) => ({
  borderRadius: 24,
  textTransform: "none",
  fontWeight: 500,
  fontSize: "1rem",
  padding: "8px 28px",
  boxShadow: "none",
  minHeight: 36,
  height: 36,
  ...(varianttype === "primary" && {
    background: "#a20034",
    color: "#fff",
    '&:hover': {
      background: "#7a0026",
      boxShadow: "none",
    },
  }),
  ...(varianttype === "secondary" && {
    background: "#ededed",
    color: "#111",
    '&:hover': {
      background: "#e0e0e0",
      boxShadow: "none",
    },
  }),
}));

export default function RoundedButton({ children, variantType, ...props }) {
  return (
    <StyledButton
      disableElevation
      variant="contained"
      varianttype={variantType}
      {...props}
    >
      {children}
    </StyledButton>
  );
}

RoundedButton.propTypes = {
  children: PropTypes.node.isRequired,
  variantType: PropTypes.oneOf(["primary", "secondary"]),
};

RoundedButton.defaultProps = {
  variantType: "primary",
};
